/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import ApproverDropdown from "./dropdown";
import styles from './dropdown.module.scss';

const ApproverDisplay = ({ details, approverOptions, onApproverChange }) => {
  return (
    <div className={styles['select-approver-dropdown']} style={{background:"white",display:"flex",width:"100%",justifyContent:"space-around",padding:"12px 24px"}}>
      <ApproverDropdown
        title="Approver 1"
        value={details.firstApprover || "Select Approver 1"} 
        onChange={(value) => onApproverChange("firstApprover", value)}
        approverOptions={approverOptions}
      />
      <ApproverDropdown
        title="Approver 2"
        value={details.secondApprover || "Select Approver 2"}
        onChange={(value) => onApproverChange("secondApprover", value)} 
        approverOptions={approverOptions}
      />
      <ApproverDropdown
        title="Approver 3"
        value={details.thirdApprover || "Select Approver 3"}
        onChange={(value) => onApproverChange("thirdApprover", value)} 
        approverOptions={approverOptions}
      />
    </div>
  );
};

ApproverDisplay.propTypes = {
  details: PropTypes.shape({
    firstApprover: PropTypes.string,
    secondApprover: PropTypes.string,
    thirdApprover: PropTypes.string,
  }),
  approverOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onApproverChange: PropTypes.func.isRequired,
};

export default ApproverDisplay;